import classNames from 'classnames';
import {Typography} from 'components/Typography';
import {MAX_COUNT_DISPLAY} from 'core/constants';
import React, {memo, ReactNode, useMemo} from 'react';
import style from './style.module.scss';

export interface IProps {
    className?: string;
    children?: ReactNode;
    count?: number;
    isInfoBadge?: boolean;
}

export const IconElement = memo<IProps>(function IconElement({children, className, count, isInfoBadge = false}) {
    const renderCount = useMemo<number | string>(() => {
        if (!count) {
            return 0;
        }

        return count > MAX_COUNT_DISPLAY ? `${MAX_COUNT_DISPLAY}+` : count;
    }, [count]);

    return (
        <div className={classNames(style.iconElement, className)}>
            <div className={style.container}>
                <Typography variant={'p-medium'}>{children}</Typography>
                {isInfoBadge && <div className={style.isInfoBadge} />}
                {Boolean(count) && (
                    <Typography
                        className={classNames(style.count, 'icon-element-count')}
                        element={'span'}
                        variant={'label-small'}
                    >
                        {renderCount}
                    </Typography>
                )}
            </div>
        </div>
    );
});
